<template>
  <div class="banner_teaser_image fade-up" v-in-viewport.once>
    <div class="inner container" @click="link">
      <div class="box">
        <picture>
          <source
            :srcset="_.get(getData, 'images.0.devices.mobile')"
            media="(max-width: 769px)"
          />
          <source
            :srcset="_.get(getData, 'images.0.devices.tablet')"
            media="(max-width: 1024px)"
          />
          <img
            :src="_.get(getData, 'images.0.devices.desktop')"
            class="absolute-img"
            :alt="_.get(getData, 'images.0.title.title')"
          />
        </picture>
        <p class="title font-55 f-light">
          {{ _.get(splitText, "sarr") }}
        </p>
        <a
          v-if="!targetBlank"
          :href="_.get(getData, 'url.url')"
          class="pointer"
        >
          <button class="button font-16 f-bold pointer">
            {{ _.get(getData, "url.title") }}
          </button>
        </a>
      </div>
      <div class="box">
        <p class="title font-34 f-light">
          {{ _.get(getData, "title") }}
        </p>
        <p class="title t1 font-55 f-light">
          {{ _.get(splitText, "farr") }}
        </p>
        <a
          v-if="targetBlank"
          :href="_.get(getData, 'url.url')"
          class="pointer"
          target="_blank"
        >
          <button class="button font-16 f-bold pointer">
            {{ _.get(getData, "url.title") }}
          </button>
        </a>
        <a
          v-if="!targetBlank"
          :href="_.get(getData, 'url.url')"
          class="pointer"
        >
          <button class="button font-16 f-bold pointer">
            {{ _.get(getData, "url.title") }}
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["contentData"],
  data() {
    return {
      brk: true
    };
  },
  mounted() {},
  methods: {
    link() {
      if (window.innerWidth < 1024) {
        window.location = _.get(this.getData, "url.url");
      }
    }
  },
  computed: {
    getData() {
      return _.get(this.contentData, "data.list.0");
    },
    splitText() {
      var txt = _.get(this.contentData, "data.list.0.title");
      var obj = {
        farr: [],
        sarr: [],
        deletedWord: [],
        correctedWord: []
      };
      // slice text in middle
      for (var i = 0; i < _.get(txt, "length"); i++) {
        if (i > _.get(txt, "length") / 2) {
          obj.sarr.push(txt[i]);
        } else {
          obj.farr.push(txt[i]);
        }
      }
      // if splited text is incorrect correct last word
      if (obj.farr[obj.farr.length - 1] !== " ") {
        for (var i = 0; i < obj.sarr.length; i++) {
          if (this.brk) {
            obj.farr.push(obj.sarr[i]);
            obj.deletedWord.push(obj.sarr[i]);
          }
          if (obj.sarr[i] === " ") {
            this.brk = false;
          }
        }
      }
      // final correct step :)
      obj.sarr = obj.sarr.slice(obj.deletedWord.length, obj.sarr.length);

      // beutiflyy text
      obj.farr = obj.farr.join("");
      obj.sarr = obj.sarr.join("");

      return obj;
    },
    targetBlank() {
      if (_.get(this.contentData, "data.list.0.url.url_target") == 1) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss">
body.white button {
  text-decoration: underline;
}
.banner_teaser_image {
  position: relative;
  margin-top: 143px;
  &.fade-up.in-view-port {
    opacity: 1;
    transform: translateY(0px);
  }
  @media (max-width: 767px) {
    margin-top: 90px;
  }
  .inner {
    a {
      margin-top: 50px;
      @media (max-width: 1023px) {
        display: none;
      }
      @media (max-width: 767px) {
        margin-top: 34px;
        padding-left: 20px !important;
        padding-right: 20px !important;
      }
      button {
        @include defBut(
          var(--primay-button-bg),
          var(--bonus-txt3),
          var(--secondarty-transparent),
          var(--white-button-txt2)
        );
      }
    }
    .t1 {
      display: none !important;
      @media (max-width: 1023px) {
        display: flex !important;
      }
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      position: relative;
      color: var(--white-no-blue2);
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 8;
      @media (max-width: 1365px) {
        font-size: 34px;
      }
      @media (max-width: 1023px) {
        font-size: 34px;
        display: none;
      }
      @media (max-width: 767px) {
        font-size: 34px;
      }
      @media (max-width: 374px) {
        font-size: 21px;
      }
    }
    @media (max-width: 1023px) {
      flex-direction: column-reverse;
      &.container {
        padding: 0px;
        width: unset;
      }
    }
    .box:nth-child(1) {
      position: relative;
      width: 390px;
      height: 627px;
      overflow: hidden;
      .title {
        color: var(--white-no-blue);
        position: relative;
        display: none;
        z-index: 3;
        @media (max-width: 1023px) {
          padding-left: 34px;
          padding-right: 34px;
          display: flex;
        }
        @media (max-width: 767px) {
          padding-left: 20px;
          padding-right: 20px;
        }
      }
      @media (max-width: 1365px) {
        width: 258px;
        height: 415px;
      }
      @media (max-width: 1023px) {
        width: 100%;
        height: unset;
        padding-bottom: 50%;
        // margin-top: -215px;
        z-index: 2;
        a {
          display: flex;
          position: relative;
          padding-left: 34px;
          padding-right: 34px;
          button {
            @include defBut(
              var(--white-button-bg),
              var(--bonus-txt2),
              var(--secondarty-transparent),
              var(--white-button-txt)
            );
          }
        }
      }
    }
    .box:nth-child(2) {
      width: 50%;
      @media (max-width: 1023px) {
        width: unset;
        position: relative;
        z-index: 1;
        padding-left: 34px;
        padding-right: 34px;
        top: 50%;
      }
      @media (max-width: 767px) {
        padding-left: 20px;
        padding-right: 20px;
      }
    }
  }
}
</style>
